import { SET_UI_STATES, CLEAR_UI_STATES } from './types';
import config from 'config';

const INITIAL_STATE = {
    theme: "light",
    learningFlowSound: false,
    practiceFlowSound: false,
    backGroundAudio: null,
};

export default function (state = INITIAL_STATE, { type, payload }) {
    switch (type) {
        case SET_UI_STATES: {
            return {
                ...state,
                ...payload,
            };
        }
        case CLEAR_UI_STATES: {
            return INITIAL_STATE;
        }
        default: return state;
    }
};